import React from "react";

export default function StatCounter({ value, suffix = "", label, duration = 1800, testId }) {
  const [n, setN] = React.useState(0);
  const ref = React.useRef(null);
  const started = React.useRef(false);

  React.useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !started.current) {
            started.current = true;
            const start = performance.now();
            const tick = (t) => {
              const p = Math.min(1, (t - start) / duration);
              const eased = 1 - Math.pow(1 - p, 3);
              setN(Math.floor(eased * value));
              if (p < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          }
        });
      },
      { threshold: 0.4 }
    );
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, [value, duration]);

  return (
    <div ref={ref} data-testid={testId} className="flex flex-col items-start gap-2 border-l border-[#B5896E]/20 pl-6 py-2">
      <span className="font-display text-5xl lg:text-6xl gold-text leading-none">
        {n.toLocaleString()}
        <span className="text-3xl lg:text-4xl ml-1">{suffix}</span>
      </span>
      <span className="caption text-[#4A3F35]/60">{label}</span>
    </div>
  );
}
